import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import { startAuthentication, startRegistration } from '@simplewebauthn/browser'
import { api } from '../utils/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const stored = localStorage.getItem('dinner_user')
    if (stored) setUser(JSON.parse(stored))
    setLoading(false)
  }, [])

  const loginWithPasskey = useCallback(async (userId) => {
    const options = await api.passkeyAuthOptions(userId || undefined)
    const { challengeKey, ...authOptions } = options
    authOptions.allowCredentials = []
    const authResponse = await startAuthentication(authOptions)
    const result = await api.passkeyAuthVerify(challengeKey, authResponse)
    localStorage.setItem('dinner_token', result.token)
    localStorage.setItem('dinner_user', JSON.stringify(result.user))
    setUser(result.user)
    return result.user
  }, [])

  const loginWithPassword = useCallback(async (userId, password) => {
    const result = await api.passwordLogin(userId, password)
    localStorage.setItem('dinner_token', result.token)
    localStorage.setItem('dinner_user', JSON.stringify(result.user))
    setUser(result.user)
    return result.user
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('dinner_token')
    localStorage.removeItem('dinner_user')
    setUser(null)
  }, [])

  return (
    <AuthContext.Provider value={{ user, loading, loginWithPasskey, loginWithPassword, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
